import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { IStaffList } from "../../models/staffList";

export const StaffActions = createActionGroup({
    source: 'Staff',
    events: {
        'Load Staff': emptyProps(),
        'Load Staff Success': props<{ staffList: IStaffList }>(),
        'Load Staff Failure': props<{ error: unknown }>(),
        'Select Staff': props<{ id: string }>(),
    }
});